import { createGlobalStyle } from "styled-components";

const appHeight = () =>
  document.documentElement.style.setProperty(
    "--app-height",
    `${window.innerHeight}px`,
  );

window.addEventListener("resize", appHeight);

appHeight();

const GlobalStyle = createGlobalStyle`
    * {
        scroll-behavior: smooth;
        
        ::-webkit-scrollbar {
            width: 5px;
            height: 5px; 
        }
        ::-webkit-scrollbar-track {
            background: ${({ theme }) => theme.colors.neutral.gray2};
        }

        ::-webkit-scrollbar-thumb {
            background: ${({ theme }) =>
              theme.colors.custom?.backgroundMenu ||
              theme.colors.primary.cetaceanBlue};
            border-radius: 20px;
        }

        ::-webkit-scrollbar-thumb:hover {
            background: ${({ theme }) =>
              theme.colors.custom?.backgroundMenu ||
              theme.colors.primary.cetaceanBlue};;
        }

        transition: 0.1s all;
    }

    input, select {
        font-family: Sora;
    }

    a {
        color: ${({ theme }) => theme.colors.primary.vividCerulean};
        text-decoration: none;
    }

    input:placeholder-shown {
        text-overflow: ellipsis;
    }

    /* Toasts (react-notifications-component) no top-left ficavam sob a navbar
       fixa (~72px). Desloca o container para baixo do menu. */
    .rnc__notification-container--top-left {
        top: 90px;
    }

    /* Fundo das notificações: azul neutro por padrão (o item base não tinha
       cor de fundo, ficando transparente). Notificações de erro/danger
       (ex.: "Documentos obrigatórios") em vermelho. */
    .rnc__notification-item {
        background-color: ${({ theme }) => theme.colors.shade.cetaceanTint1};
        border-left: 8px solid #0a143c;
    }
    .rnc__notification-item .rnc__notification-timer {
        background-color: ${({ theme }) => theme.colors.shade.cetaceanTint1};
    }
    .rnc__notification-item--danger {
        background-color: ${({ theme }) =>
          theme.colors.feedbackState.critical.default};
        border-left-color: ${({ theme }) =>
          theme.colors.feedbackState.critical.darked};
    }
    .rnc__notification-item--danger .rnc__notification-timer {
        background-color: ${({ theme }) =>
          theme.colors.feedbackState.critical.default};
    }

    html {
        box-sizing: border-box;
        overflow-y: scroll;
        overflow-y: overlay;

        overflow-x: hidden;

        button {
            cursor: pointer;
        }
        img {
            image-rendering: smooth;
        }
        img, button { 
            -webkit-user-drag: none; 
            -khtml-user-drag: none; 
            -moz-user-drag: none; 
            -o-user-drag: none; 
            user-drag: none; 
            user-select: none;
            background-color: transparent;
            border: none;
            
        }
        *, *::before, *::after {
            box-sizing: inherit;
            padding: 0;
            margin: 0;
        
        }
    }
    /* ANIMATIONS */
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: scale(1);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
  }
`;

export default GlobalStyle;
